import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavBarService {
	names = ['pressure','mobile','locked','chimneysweep','installer','ecomode','adjusttime'];
	states = ['on','off','blinking'];
	
	elementStates : Map<string,string>;
  
  constructor() { 
  	this.elementStates = new Map<string,string>();
  	this.disableAll();
  }

  getState(icon:string):string{
  	if(this.elementStates.has(icon)){
  		return this.elementStates.get(icon);
  	}else{
  		return 'off';
  	}
  }
  blink(icon:string){
  	this.elementStates.set(icon,'blinking');
  }
  enable(icon:string){
  	this.on(icon);
  }
  on(icon:string){
  	this.elementStates.set(icon,'on');
  }
  off(icon:string){
  	this.elementStates.set(icon,'off');
  }
  disableAll(){
	for(let item of this.names){
		console.log("setting item "+item + " to off");
  		this.elementStates.set(item,'off');
  	}
  }

  enableAll(){
	for(let item of this.names){
	  		this.elementStates.set(item,'on');
  	}
  }

}
